import React, { useContext } from "react";

import { Commodity } from "../products/products";
import { useFilter } from "./Filter";
import {
    FilteredCommodities,
    empty_value,
    filterByProductClass,
    filterByProductName,
    filterByProductOwnership,
    filterCommoditiesByEmptyTags,
    filterCommoditiesByStatus,
    filterCommoditiesByTags,
    filterCommoditiesByText,
    free_text_filter,
    product_class_filter,
    product_filter,
    product_ownership_filter,
    tag_filter,
} from "./utils";
import { FilterConfig } from "./utils";
import { useProducts } from "../products/ProductsProvider";
import { useTags } from "src/tags/TagsProvider";
import { translateForProducts } from "./IpStatusFilter";

const FilteredCommoditiesContext = React.createContext({
    commodities: [] as Commodity[],
    /// we are specifically looking for cases where patents are not mapped to products
    isLookingForEmpty: false as boolean,
})

export function FilteredCommoditiesProvider({ children }) {
    const { showActiveOnly, activeFilters, ipStates } = useFilter()
    const { tagsLookup } = useTags();

    //console.log({activeFilters})

    const { commodities } = useProducts();

    const fullContext = activeFilters
        .filter(({ isActive }) => isActive)
        .reduce(
            (ctxt: FilteredCommodities, filter: FilterConfig) => {
                switch (filter.name) {
                    case tag_filter:
                        if (filter.config === 'empty')
                            return filterCommoditiesByEmptyTags(ctxt, tagsLookup);
                        else
                            return filterCommoditiesByTags(ctxt, filter.config, tagsLookup);
                    case product_ownership_filter:
                        return filterByProductOwnership(ctxt, filter.config?.value);
                    case free_text_filter:
                        return filterCommoditiesByText(ctxt, filter.config);
                    case product_filter:
                        return filterByProductName(ctxt, filter.config);
                    case product_class_filter:
                        return filterByProductClass(ctxt, filter.config)
                    default:
                        return ctxt;
                }
            },
            { commodities } // TODO get rid of commodities here
        );

    const value = filterCommoditiesByStatus(fullContext, ipStates.map(translateForProducts))

    // console.log({activeFilters})
    const isLookingForEmpty = activeFilters.some(({ name, config }) => name === product_filter && (config as string[]).includes(empty_value));

    return (
        <FilteredCommoditiesContext.Provider value={{...value, isLookingForEmpty}}>{children}</FilteredCommoditiesContext.Provider>
    );
}

export function useFilteredCommodities() {
    return useContext(FilteredCommoditiesContext);
}
